import styles from './ContentSection.module.css';
import PropTypes, { node } from 'prop-types';

/**
 * 컨텐츠 영역 Container
 * 자식 노드가 있는 경우, 자식 노드를 렌더링함 (일반적으로 <table> 태그로 시작)
 * 자식 노드가 없는 경우, 렌더링 X
 * @returns
 */
function ContentSection({ children, width, height, header, headerType, headerBtn }) {
  if (children) {
    return (
      <>
        <div className={styles.contentSection} style={{ width: width, height: height }}>
          {/* 우측 Combo, Btn 등 Comp */}
          {/* 각 페이지에서 Comp, Biz Logic 구현 */}
          {headerBtn ? <div className={styles.contentHeaderBtn}>{headerBtn}</div> : null}

          {/* 좌측 Header */}
          {header && headerType === 'default' ? (
            <div className={styles.contentHeaderDefault}>
              <ul>
                <li>{header}</li>
              </ul>
            </div>
          ) : header && headerType === 'bold' ? (
            <div className={styles.contentHeaderBold}>
              <span>{header}</span>
            </div>
          ) : null}

          {children}
        </div>
      </>
    );
  }
}

ContentSection.defaultProps = {
  width: '100%',
  headerType: 'default', // default, bold
};

ContentSection.propTypes = {
  children: PropTypes.node,
  header: PropTypes.string,
  headerType: PropTypes.string,
};

export default ContentSection;
